import { Box, Flex, HStack } from '@sevenrooms/ui-kit/layout'
import { SkeletonBox } from '../../../../components/SkeletonBox'

interface TimeSlotsSkeletonProps {
  showHeader?: boolean
}

export function TimeSlotsSkeleton({ showHeader }: TimeSlotsSkeletonProps) {
  return (
    <Box>
      {showHeader && <SkeletonBox width="100px" height="20px" mb="m" data-test="sr-loading-header" />}
      <HStack spacing="sm" overflowX="scroll">
        <Flex flex="0 0 150px">
          <SkeletonBox height="59px" />
        </Flex>
        <Flex flex="0 0 150px">
          <SkeletonBox height="59px" />
        </Flex>
        <Flex flex="0 0 150px">
          <SkeletonBox height="59px" />
        </Flex>
        <Flex flex="0 0 150px">
          <SkeletonBox height="59px" />
        </Flex>
        <Flex flex="0 0 150px">
          <SkeletonBox height="59px" />
        </Flex>
      </HStack>
    </Box>
  )
}
